<template>
  <div class="agancy-module">
    <div class="title">
      <h4>آژانس‌های گردشگری</h4>
      <div class="container-fluid p-1">

        <div class="item-container">


          <div class="d-flex flex-row" v-for="i in rowCount">
            <div class="col-6" v-for="item in itemCountInRow(i)" :key="item.id">
              <router-link class="card" :to="`/agancy/${item.id}`" tag="div">
                <img :src="`https://kishoto.ir/dtr/approid/img/${item.image}`" />
                <p>{{ item.name }}</p>
              </router-link>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      agancy: [],
      itemsPerRow:2,
    };
  },
  computed: {
    rowCount:function() {
      return Math.ceil(this.agancy.length / this.itemsPerRow);
    }
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const response = await this.$ApiServiceLayer.post("agency_list");
      if (response.status_code === 200) {
        this.agancy = response.list;
      }
    },
    itemCountInRow:function(index){
      return this.agancy.slice((index - 1) * this.itemsPerRow, index * this.itemsPerRow)
    }
  },
};
</script>

<style lang="scss" scoped>
.agancy-module {
  width: 100%;
  min-height: 100vh;
  background-image: url("~@/assets/img/bg/onepack_back.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0px;
  direction: rtl;
  .title {
    text-align: center;
    h4 {
      font-family: "sans";
      color: #fff;
      padding-top: 23px;
    }
  }
  .item-container {
    margin-top: 50px;
    .card {
      width: 100%;
      height: 171px;
      background-color: #fff;
      border-radius: 10px;
      padding: 5px;
      cursor: pointer;
      img {
        height: 135px;
        object-fit: cover;
        border-radius: 10px;
      }
      p {
        font-size: 14px;
        font-family: "sans";
        margin-top: 5px;
      }
    }
  }
}
</style>
